<template>
    <div id="app" data-app="true">
        <div>
            <preloader v-show="this.$store.state.preloader"></preloader>
            <vueadmin_header/>
            <div v-if="requiresPerms" class="wrapper row-offcanvas">
                <left_side v-show="this.$store.state.left_open"></left_side>
                <right_side>
                    <router-view></router-view>
                </right_side>
            </div>

            <div v-if="!requiresPerms" class="wrapper row-offcanvas">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import './assets/sass/custom.scss'
import './components/layouts/css/fixed-menu.scss'
import vueadmin_header from './components/layouts/header/fixed-header'
import preloader from './components/layouts/preloader/preloader'
import right_side from './components/layouts/right-side'
import left_side from './components/layouts/left-side/default/left-side'
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import ToggleButton from 'vue-js-toggle-button'

import anime from 'animejs'
import Vuetify from 'vuetify'
import VueCurrencyFilter from 'vue-currency-filter'

import miniToastr from 'mini-toastr';
miniToastr.init();
Vue.use(Vuetify)
Vue.use(ToggleButton)
Vue.use(BootstrapVue);
Vue.use(VueCurrencyFilter,
{
    symbol : '',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
})

export default {
    name: 'app',
    props: ['protectedPath'],
    components: {
        preloader,
        vueadmin_header,
        left_side,
        right_side
    },
    computed: {
        requiresPerms: {
            get: function() {
                if (typeof this.$route.meta.requiresPermissions != 'undefined') {
                    return true;
                } else {
                    return false;
                }
            }
        }
    },
    watch: {
        requiresPerms: {
            immediate: true,

            handler(newVal, oldVal) {
            }
        }
    },
    data() {
        return {
            showtopbtn: false
        }
    },
    created() {
        this.$store.dispatch('getConstants');
    },
    beforeCreate: function () {

    },
    mounted: function () {
        if (window.innerWidth <= 992) {
            this.$store.commit('left_menu', 'close')
        }
    }
}
</script>

<style lang="scss" src="./assets/sass/bootstrap/bootstrap.scss"></style>
<style src="@fortawesome/fontawesome-free/css/all.css"></style>
<style src="font-awesome/css/font-awesome.css"></style>
<style src="bootstrap-vue/dist/bootstrap-vue.css"></style>

<style lang="scss" scoped>
    /*
    #app::after {
        content:'';
        display:block;
        position: fixed;
        z-index: 1500;
        left: calc(100% - 57px);
        top: 66px;
        border-radius: 20px;
        background-color: transparent;
        border-width: 15px;
        border-style: double;
        border-color: transparent #428bca;
        animation: cssload-anim 0.7s linear infinite;
        @media screen and (max-width: 560px) {
                top: 106px;
        }
    }
    #app.loaded::after {
        display:none;
    }
    @keyframes cssload-anim {
        0% {
                transform: rotate(0deg);
        }
        100% {
                transform: rotate(360deg);
        }
    }
    */

    .wrapper:before,
    .wrapper:after {
        display: table;
        content: " ";
    }

    .wrapper:after {
        clear: both;
    }

    .wrapper {
        display: table;
        overflow-x: hidden;
        width: 100%;
        max-width: 100%;
        table-layout: fixed
    }

    .right-aside,
    .left-aside {
        padding: 0;
        display: table-cell;
        vertical-align: top;
    }

    .right-aside {
        background-color: #ebf2f6 !important;
    }

    @media (max-width: 992px) {
        .wrapper > .right-aside {
            width: 100vw;
            min-width: 100vw;
        }
    }
</style>




// WEBPACK FOOTER //
// src/App.vue